import { render, staticRenderFns } from "./ProjectPreviewQuestionBuilder.vue?vue&type=template&id=53f685b1&scoped=true"
import script from "./ProjectPreviewQuestionBuilder.vue?vue&type=script&lang=js"
export * from "./ProjectPreviewQuestionBuilder.vue?vue&type=script&lang=js"
import style0 from "./ProjectPreviewQuestionBuilder.vue?vue&type=style&index=0&id=53f685b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f685b1",
  null
  
)

export default component.exports